module.exports = __webpack_public_path__ + "img/ceramic-purple.60bf6db8.png";